
import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import Dialog from 'material-ui/Dialog';
import { CancelButton,SubmitButtonModal } from '../../../components/buttons';
import { displayCustomError } from '../../../actions/utilAction';
import { MODULE } from '../constants/ApiConstants';
import { resetUserEmail } from '../actions/UserActions';
import { renderTextField } from '../../../components/reduxFields';
import SmallLoader from '../../../img/small-loader.gif';
import { checkFieldExistence } from '../../AppConfig/actions';
import validate from './validate';

class ChangeEmailAddressModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            
        }
    }

    handleClose = () => {
        this.props.closeDialog();
    }

    onSubmitHandler= async(formData) =>{
        if ((this.props.fieldError && this.props.fieldError.length) || (this.props.fieldErrorLoading)) { // Avoid Submit if field error checking
            return null;
        }
        let postData = {
            "UserId": this.props.userId,
            "NewEmail": formData.email,
            }
        
        try {
            await this.props.resetUserEmail(postData);
            } catch (error) {
                console.error("Error sending mail:", error); // Reference the error correctly
            }
        this.props.closeDialog();
    }
    
    checkFieldDataExistence = (input, value, labelName) => {
        if (value.length > 0) {
          let postData = {
            'labelName': labelName,
            'tableName': `${MODULE}_${input.target.name}`.toUpperCase(),
            'value': value,
            'colmnName': input.target.name.toUpperCase(),
            'id': this.props.userID ? this.props.userID : 0,
          };
          this.props.checkFieldExistence(postData);
        }
    };
    

    renderLoading() {
        return (
            <div>
                {this.props.loading ? (
                    <div className="full_loader top0">
                        <div className="small-loader">
                            <img src={SmallLoader} alt="" />
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }

    render() {
        const { handleSubmit } = this.props;
      
        return (
            <div>
                <Dialog
                    className="custom_modal"
                    title='Change Email Address'
                    modal={false}
                    open={true}
                    autoScrollBodyContent={true}
                >
                    {this.renderLoading()}
                    <div className="row">
                        <div className="col-sm-12">
                            <form className="readmin-form custom_form" >
                                <div className="row">
                                    <div className="col-sm-12">
                                        <Field
                                            name="email"
                                            label="New Email Address"
                                            type="text"
                                            maxLength="60"
                                            onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'Email')}
                                            customError={displayCustomError('EMAIL', this.props.fieldError)}
                                            component={renderTextField} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12 pt20 btn_rt">
                                        <CancelButton className="mr-15" onTouchTap={this.handleClose} />
                                        <SubmitButtonModal className="ml_15" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} primary={true} label="Send Verification Email" />
                                    </div>
                                </div>
                                <div className='mt-2'style={{color:"black"}}>
                                    <em>
                                    If the current email address is invalid or no longer accessible, please reach out to your agency administrator for assistance.
                                    </em>
                                </div>
                            </form>
                        </div>
                    </div>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    let userID = 0;
    let fieldError_Email = null;
    if (ownProps.staffId && state.user.staffDetails && state.user.staffDetails.data) {
        let staffDetails = state.user.staffDetails.data
        userID = staffDetails.userID;
    }
    if (state.appConfig && state.appConfig.fieldError) {
        fieldError_Email = state.appConfig.fieldError.filter((obj, i) => obj.data === 'EMAIL');
    }
    return {
        userID: userID,
        fieldError: state.appConfig.fieldError,
        fieldErrorLoading: state.appConfig.fieldErrorLoading,
    };
};

ChangeEmailAddressModal = reduxForm({
    form: 'ChangeEmailAddressModal', // a unique identifier for this form
    validate,
})(ChangeEmailAddressModal);

export default connect(mapStateToProps,{resetUserEmail, checkFieldExistence})(ChangeEmailAddressModal);



// WEBPACK FOOTER //
// ./src/modules/users/User/ChangeEmailAddressModal.js